import styled, { DefaultTheme } from 'styled-components';

export interface TextProps {
  level: '1' | '2' | '3';
  colorName?: keyof DefaultTheme['colors'];
}

export type ITextGetSizeMap = (globalTheme: DefaultTheme) => {
  [ key in TextProps['level'] ]: number;
};

const getSizeMap: ITextGetSizeMap = (globalTheme) => ({
  1: globalTheme.fontSize.md,
  2: globalTheme.fontSize.sm,
  3: globalTheme.fontSize.xs
});

const Text = styled.div<TextProps>`
  font-size: ${({ level, theme }) => getSizeMap(theme)[level]}px;
  color: ${({ colorName, theme }) => colorName ? theme.colors[colorName] : 'inherit'};
  line-height: 1.2;
  
  b {
    font-weight: 600;
  }
`;

export { Text };
